window.sfs = window.sfs || {};
window.sfs.utils = window.sfs.utils || {};

window.addEventListener("DOMContentLoaded", () => {
  const modules = document.querySelectorAll("[data-sfs-module]");

  modules.forEach((el) => {
    const module = el.dataset.sfsModule;
    const intervalMs = parseInt(el.dataset.intervalMs, 10) || 60000;
    const countdownDate = el.dataset.countdownDate || null;
    const kat = el.dataset.kat || "";

    const config = { container: el, intervalMs, countdownDate, kat };

    switch (module) {
      case "skiday":
        window.sfs.SkiDay.init(config);
        break;
      case "openair":
        window.sfs.Openair.init(config);
        break;
      default:
        return;
    }
  });
});

window.sfs.utils.loadCountdown = async function (countdownDate, container) {
  try {
    if (!countdownDate) return;
    const diffDays = Math.ceil((new Date(countdownDate) - new Date()) / 86400000);
    const el = container.querySelector(".keyvalue-3");
    if (el && el.textContent !== String(diffDays)) {
      el.textContent = diffDays;
    }
  } catch (err) {
    console.error("Fehler beim Countdown:", err);
  }
};

window.sfs.utils.startCountdownInterval = function (countdownDate, container, interval = 86400000) {
  if (!countdownDate) return;
  if (container._countdownInterval) clearInterval(container._countdownInterval);

  window.sfs.utils.loadCountdown(countdownDate, container);

  container._countdownInterval = setInterval(() => {
    window.sfs.utils.loadCountdown(countdownDate, container);
  }, interval);
};

window.sfs.Openair = (() => {
  async function loadData(container) {
    try {
      const response = await fetch("https://newsletter.sfs.biz/p/de.pinuts.sfs.api/getopenairkeyvalue");
      const data = await response.json();
      if (!Array.isArray(data) || !Array.isArray(data[0])) return;

      const [total, helper] = data[0];
      const totalEl = container.querySelector(".keyvalue-1");
      const helperEl = container.querySelector(".keyvalue-2");

      if (totalEl) totalEl.textContent = String(total);
      if (helperEl) helperEl.textContent = String(helper);
    } catch (err) {
      console.error("Fehler bei Openair-Zahlen:", err);
    }
  }

  function startInterval(container, intervalMs) {
    if (container._openairInterval) clearInterval(container._openairInterval);
    container._openairInterval = setInterval(() => {
      loadData(container);
      if (container.dataset.countdownDate) {
        window.sfs.utils.loadCountdown(container.dataset.countdownDate, container);
      }
    }, intervalMs);
  }

  async function init({ container, intervalMs = 60000, countdownDate }) {
    await loadData(container);
    if (countdownDate) {
      window.sfs.utils.startCountdownInterval(countdownDate, container);
    }
    startInterval(container, intervalMs);
  }

  return { init };
})();

window.sfs.SkiDay = (() => {
  async function loadData(container, kat) {
    try {
      const response = await fetch(`https://newsletter.sfs.biz/p/de.pinuts.sfs.api/getskidaykeyvalue?kat=${encodeURIComponent(kat)}`);
      const data = await response.json();
      if (!Array.isArray(data) || !Array.isArray(data[0])) return;

      const [value] = data[0];
      const el = container.querySelector(".keyvalue-1");
      if (el) el.textContent = String(value);
    } catch (err) {
      console.error("Fehler bei Skitag-Zahlen:", err);
    }
  }

  function startInterval(container, intervalMs, kat) {
    if (container._skiDayInterval) clearInterval(container._skiDayInterval);
    container._skiDayInterval = setInterval(() => {
      loadData(container, kat);
      if (container.dataset.countdownDate) {
        window.sfs.utils.loadCountdown(container.dataset.countdownDate, container);
      }
    }, intervalMs);
  }

  async function init({ container, intervalMs = 60000, kat = "", countdownDate }) {
    await loadData(container, kat);
    if (countdownDate) {
      window.sfs.utils.startCountdownInterval(countdownDate, container);
    }
    startInterval(container, intervalMs, kat);
  }

  return { init };
})();